import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "llmCheckbox", "submitBtn", "result"]

  run(event) {
    event.preventDefault()

    const question = this.inputTarget.value.trim()
    if (!question) return

    const runLlm = this.llmCheckboxTarget.checked

    // Show loading state
    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = runLlm ? "Running LLM..." : "Testing..."
    this.resultTarget.innerHTML = `
      <div class="bg-gray-50 rounded-lg border border-gray-200 p-12 text-center">
        <div class="lz-spinner-icon h-6 w-6 mx-auto mb-3"></div>
        <p class="text-sm text-gray-500">${runLlm ? 'Running full pipeline with LLM...' : 'Running schema resolution...'}</p>
      </div>
    `

    const form = event.target
    const formData = new FormData(form)

    fetch(form.action, {
      method: 'POST',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: formData
    })
      .then(response => response.text())
      .then(html => {
        // Turbo stream will auto-update the DOM
        Turbo.renderStreamMessage(html)
        // Re-init icons in the result panel
        if (window.lucide) window.lucide.createIcons()
      })
      .catch(error => {
        this.resultTarget.innerHTML = `
          <div class="bg-red-50 rounded-lg border border-red-200 p-4">
            <p class="text-sm text-red-700">Error: ${error.message}</p>
          </div>
        `
      })
      .finally(() => {
        this.submitBtnTarget.disabled = false
        this.submitBtnTarget.textContent = "Test"
      })
  }
}
